import { emphasize, SxProps, Theme } from "@mui/material/styles";
import theme from "../../theme";

const style: SxProps<Theme> = [
  {
    width: "100%",
    flexGrow: 1,
    minWidth: 290,
    border: "1px solid " + theme.palette.primary.main,
    background: "white",
    "& .textFieldLabel ": {
      top: 0,
      left: 0,
      zIndex: 1,
      position: "absolute",
      color: "#000000",
      fontSize: "0.8rem",
      transform: "translate(12px, 12px) scale(1)",
      fontWeight: "700",
      transition:
        "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
      "&.Mui-focused, &.AutoComplete-labelShrink": {
        transform: "translate(12px, 4px) scale(0.75)",
        fontSize: "1em",
        fontWeight: "normal",
        color: theme.palette.grey[400],
      },   
      "&.MuiInputLabel-shrink": {
          transform: "translate(12px, 4px) scale(0.75)",
          fontSize: "1em",
          fontWeight: "normal",
          color: theme.palette.grey[400],
        },
    },
    "& fieldset": {
      display: "none",
    },
    "& .MuiInputBase-root": {
      marginTop: 0,
      display: "flex",
      justifyContent: "space-between",
      padding: 0,
      height: 42,
      fontWeight: "700",
      "&.MuiOutlinedInput-root .MuiAutocomplete-input": {
        pl: "12px",
        pt: "12px",
        pr: "12px",
      },
    },

    "& .MuiInputAdornment-root": {
      mt: "-6px",
    },
    "& .valueContainer": {
      display: "flex",
      flexWrap: "wrap",
      flex: 1,
      alignItems: "center",
      overflow: "hidden",
      paddingLeft: "12px",
    },
    // "& .chip": {
    //   margin: theme.spacing(0.5, 0.25),
    // },
    // "& .chipFocused": {
    //   backgroundColor: emphasize(theme.palette.grey[300], 0.08),
    // },
    // "& .noOptionsMessage": {
    //   padding: theme.spacing(1, 2),
    //   fontSize: 13,
    // },
    // "& .singleValue": {
    //   padding: "15px 12px 7px 0",
    //   fontSize: "0.9rem",
    //   fontWeight: "bold",
    // },
    // "& .placeholder": {
    //   position: "absolute",
    //   left: 2,
    //   bottom: 6,
    //   fontSize: 16,
    // },
    // "& .paper": {
    //   position: "absolute",
    //   zIndex: 10,
    //   left: 0,
    //   right: 0,
    // },
    // "& .divider": {
    //   height: theme.spacing(2),
    // },
  },
];
export default style;
